import React, { ReactNode, useState } from 'react'
import { Dropdown } from "antd";
import { DropDownProps } from "antd/lib/dropdown";

interface IDropdownPropTypes extends DropDownProps {
  children: ReactNode;
  overlay: any;
  trigger?: ("click" | "hover" | "contextMenu")[];
  onChange: () => void;
}

interface DropdownWrapperPropTypes {
  children: ReactNode;
}

export const DropdownWrapper = ({ children }: DropdownWrapperPropTypes) => {
  return (
    <div className="dropdown-wrapper shadow-md rounded-lg overflow-hidden border-t-2 border-electric-violet">
      {children}
    </div>
  );
};

const SkyeDropdown = ({
  onChange,
  children,
  overlay,
  trigger,
  ...props
}: IDropdownPropTypes) => {
  const [visible, setVisible] = useState(false);

  return (
    <Dropdown
      {...props}
      trigger={trigger}
      className="skye-dropdown"
      open={visible}
      onOpenChange={(newOpen) => {
        setVisible(newOpen);
        onChange();
      }}
      overlayStyle={{ zIndex: 4300 }}
      overlay={<div onClick={() => setVisible(false)}>{overlay}</div>}
    >
      {children}
    </Dropdown>
  );
};

export default SkyeDropdown;
